import React, { useState, useRef } from "react";
import { useQuery } from "react-query";
import { DataTable } from "primereact/datatable";
import authApi from "../../../service/IdApi";
import PageLoadError from "../../../components/PageLoadError";
import PageHeading from "../../../components/PageHeading";
import { Column } from "primereact/column";
import { Button } from 'primereact/button';
import { useAppContext } from "../../../context/appContext";
import { Dialog } from "primereact/dialog";

const CanceledSubscriptions = () => {
    const { switchUnclaimedProfile } = useAppContext();
    const [providers, setProviders] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loaded, setLoaded] = useState(false);
    const dataTable = useRef(null);
    const [showDetailsDialog, setShowDetailsDialog] = useState(false);
    const [subscriptionTableState, setSubscriptionTableState] = useState(() => {
        return {
            first: 0,
            rows: 25,
            page: 1,
            sortField: "updatedAt",
            sortOrder: -1
        };
    });
    const [selectedProvider, setSelectedProvider] = useState(null);
    const [users, setUsers] = useState([]);

    const { isLoading, isFetching, isError, data, refetch } = useQuery(["CanceledSubscriptions", subscriptionTableState], async () => {
        var body = {};
        body.first = subscriptionTableState.first;
        body.rows = subscriptionTableState.rows;
        body.sortField = subscriptionTableState.sortField;
        body.sortOrder = subscriptionTableState.sortOrder;
        body.status = ["canceled"];
        const result = await authApi.post("admin/provider/canceled-subscriptions", body);
        setProviders(result.data.subscriptions);
        setTotalRecords(result.data.totalRecords);
        setLoaded(true);
        return data;
    });

    const pageHeader = (
        <PageHeading pageTitle="Admin - Canceled Subscriptions">
            <div className="block">
            </div>
        </PageHeading>
    );

    if (isError) {
        return (
            <div>
                {pageHeader}
                <PageLoadError />
            </div>
        );
    }

    const onPage = (event) => {
        setSubscriptionTableState(event);
    };

    const onSort = (event) => {
        setSubscriptionTableState(event);
    };

    const exportCSV = (selectionOnly) => {
        dataTable.current.exportCSV({ selectionOnly });
    };

    const nameClicked = (e) => {
        e.preventDefault();
        switchUnclaimedProfile(selectedProvider.provider.name, selectedProvider.providerId, null);
    }

    const nameBodyTemplate = (rowData) => {
        return (
            <div className="">
                {rowData.provider && (
                    <a href="#" onClick={(e) => rowClicked(e, rowData)}>
                        {rowData.provider.name}
                    </a>
                )}
                {!rowData.provider && (
                    <span>[{rowData.providerId}]</span>
                )}
            </div>
        );
    };

    const rowClicked = async (e, rowData) => {
        e.preventDefault();
        setSelectedProvider(rowData);
        var body = {};
        body.providerId = rowData.providerId;
        const result = await authApi.post("admin/provider/users", body);
        setUsers(result.data.users);
        setShowDetailsDialog(true);
    }

    const hideDetailsDialog = () => {
        setShowDetailsDialog(false);
    }

    const updatedAtBodyTemplate = (rowData) => {
        return (
            <span>{new Date(rowData.updatedAt).toLocaleDateString()}</span>
        );
    }

    const emailBodyTemplate = (rowData) => {
        return (
            <div>
                <a href={`/account/admin/user-events?email=${rowData.email}`}>
                    {rowData.email}
                </a>
            </div>
        );
    }

    return (
        <div>
            {pageHeader}
            <div className="layout-content">
                <div className="card pt-3 sm:pt-0">
                    <div className="flex py-3 w-full">
                        <div className="flex flex-row text-lg align-items-center">
                            These are service providers that have canceled their subscription.
                        </div>
                        <div className="flex flex-row flex-grow-1 justify-content-end">
                            <Button type="button" icon="pi pi-file-export" rounded onClick={() => exportCSV(false)} data-pr-tooltip="CSV" label="Export" />
                        </div>
                    </div>
                    <DataTable
                        ref={dataTable}
                        value={providers}
                        dataKey="providerId"
                        paginator
                        rows={subscriptionTableState.rows}
                        rowsPerPageOptions={[25, 50, 100]}
                        className="datatable-responsive"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} providers"
                        emptyMessage="No providers found."
                        lazy
                        first={subscriptionTableState.first}
                        totalRecords={totalRecords}
                        onPage={onPage}
                        onSort={onSort}
                        sortField={subscriptionTableState.sortField}
                        sortOrder={subscriptionTableState.sortOrder}
                        loading={isLoading || isFetching || !loaded}
                    >
                        <Column body={nameBodyTemplate} field="name" header="Name" sortable />
                        <Column field="updatedAt" body={updatedAtBodyTemplate} header="Last Updated On" sortable />
                    </DataTable>
                </div>
                <Dialog
                    visible={showDetailsDialog}
                    style={{ width: '50vw' }}
                    breakpoints={{ '1280px': '75vw', '641px': '95vw' }}
                    header="Canceled Subscription Details"
                    modal
                    onHide={hideDetailsDialog}
                    className="p-fluid"
                >
                    {selectedProvider && (
                        <div>
                            <div className="field grid mb-0">
                                <label className="col-fixed" style={{ width: '150px' }}>Name</label>
                                <div className="col">
                                    <a href="#" onClick={(e) => nameClicked(e)}>
                                        {selectedProvider.provider.name}<span className="ml-2 pi pi-arrow-right-arrow-left" style={{ fontSize: '.8rem' }} />
                                    </a>
                                </div>
                            </div>
                            <div className="field grid mb-0">
                                <label className="col-fixed" style={{ width: '150px' }}>Provider ID</label>
                                <div className="col">{selectedProvider.providerId}</div>
                            </div>
                            <div className="field grid mb-0">
                                <label className="col-fixed" style={{ width: '150px' }}>Provider Number</label>
                                <div className="col">{selectedProvider.provider.providerNumber}</div>
                            </div>
                            <div className="field grid mb-0">
                                <label className="col-fixed" style={{ width: '150px' }}>Created On</label>
                                <div className="col">{selectedProvider.createdAt}</div>
                            </div>
                            {selectedProvider.provider && (
                                <>
                                    <div className="field grid mb-0">
                                        <label className="col-fixed" style={{ width: '150px' }}>City</label>
                                        <div className="col">{selectedProvider.provider.city}</div>
                                    </div>
                                    <div className="field grid mb-0">
                                        <label className="col-fixed" style={{ width: '150px' }}>State</label>
                                        <div className="col">{selectedProvider.provider.stateName}</div>
                                    </div>
                                    <div className="field grid mb-0">
                                        <label className="col-fixed" style={{ width: '150px' }}>Zip Code</label>
                                        <div className="col">{selectedProvider.provider.zipCode}</div>
                                    </div>
                                    <div className="field grid mb-0">
                                        <label className="col-fixed" style={{ width: '150px' }}>Country</label>
                                        <div className="col">{selectedProvider.provider.countryName}</div>
                                    </div>
                                    <div className="field grid mb-0">
                                        <label className="col-fixed" style={{ width: '150px' }}>Timezone</label>
                                        <div className="col">{selectedProvider.provider.timezone}</div>
                                    </div>
                                </>
                            )}
                            <div className="field grid mb-0">
                                <label className="col-fixed" style={{ width: '150px' }}>Users</label>
                            </div>
                            <DataTable
                                value={users}
                                dataKey="userId"
                                className="datatable-responsive"
                            >
                                <Column field="userId" header="ID" sortable />
                                <Column body={emailBodyTemplate} field="email" header="Email" sortable />
                                <Column field="createdAt" header="Created On" sortable />
                            </DataTable>
                        </div>

                    )}
                </Dialog>
            </div>
        </div>
    );
};

export default CanceledSubscriptions;
